import script from "./Uploader.vue?vue&type=script&setup=true&lang=js"
export * from "./Uploader.vue?vue&type=script&setup=true&lang=js"

import "./Uploader.vue?vue&type=style&index=0&id=155a3836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155a3836"]])

export default __exports__